import React, { useMemo } from "react";
import { withTranslation } from "react-i18next";
import { Col, Row } from "reactstrap";
import { get } from "lodash";
import PropTypes from "prop-types";

import { getOptionLabel } from "common/enums";
import Collapse from "./Collapse";

const AccessHolderView = ({
  accessHolderData,
  accessCardHolderType,
  isExpandable = true,
  t,
}) => {
  const isEmployee =
    getOptionLabel("utilityTunnelConsumerType", accessCardHolderType) ===
    "Employee";

  const fields = useMemo(
    () => [
      {
        name: "First Name",
        key: "firstName",
        isRequired: true,
      },
      {
        name: "Last Name",
        key: "lastName",
        isRequired: true,
      },
      ...(isEmployee
        ? [
            {
              name: "Employee Id",
              key: "employeeId",
              isRequired: true,
            },
            {
              name: "Designation",
              key: "designation",
              renderField: (value) => (value ? value : "N/A"),
            },
          ]
        : []),

      ...(!isEmployee
        ? [
            {
              name: "Contractor Company Name",
              key: "companyName",
              isRequired: true,
            },
            {
              name: "Sub Contractor/Firm Name",
              key: "subContractor",
              renderField: (value) => (value ? value : "N/A"),
            },
            {
              name: "Purpose of visit",
              key: "purposeOfVisit",
              renderField: (value) => (value ? value : "N/A"),
            },
          ]
        : []),

      {
        name: "Mobile Number",
        key: "mobileNumber",
        isRequired: true,
      },
      {
        name: "Email",
        key: "email",
        isRequired: true,
      },
      {
        name: isEmployee ? "GIFT CITY Department" : "Applied in GIFT CITY Department",
        key: "departmentId",
        renderField: (value) =>
          getOptionLabel("utilityTunnelDepartments", value) ?? "-",
      },
      ...(!isEmployee
        ? [
            {
              name: "Applied in GIFT CITY Section",
              key: "utaCardIssuanceRole.id",
              renderField: (value) =>
                getOptionLabel("capexOpexOptionsType", value) ? getOptionLabel("capexOpexOptionsType", value):"N/A",
            },
          ]
        : []),
    ],
    []
  );

  return (
    <>
      <Collapse
        title={`${getOptionLabel(
          "utilityTunnelConsumerType",
          accessCardHolderType
        )} Details`}
        isExpandable={isExpandable}
      >
        <Row className="d-flex  mb-2">
          {fields.map(({ name, key, isRequired, renderField }) => {
            const value = get(accessHolderData, key, "");
            return (
              <Col key={key} lg={6} className="mb-1">
                <Row>
                  <Col md={5}>{t(name)}:</Col>
                  <Col
                    md={7}
                    className="fw-semibold"
                    style={{ wordBreak: "break-word" }}
                  >
                    {renderField
                      ? renderField(value)
                      : get(accessHolderData, key, null) ??
                        (isRequired ? "-" : "N/A")}
                  </Col>
                </Row>
              </Col>
            );
          })}
        </Row>
      </Collapse>
    </>
  );
};

AccessHolderView.propTypes = {
  accessHolderData: PropTypes.object,
  isExpandable: PropTypes.bool,
  accessCardHolderType: PropTypes.number,
  t: PropTypes.func,
};

export default withTranslation()(AccessHolderView);
